import http from '@/plugins/axios.instance';
import loginMapper from '@/http/login.mapper';
import loginService from '@/services/login.service';
import languageService from '@/services/language.service';
import { Credentials } from '@/interfaces/credentials.interface';
import { CxServiceUnavailableError } from '@/classes/error.class';
import { AxiosResponse } from 'axios';

const loginUrl = process.env.VUE_APP_LOGIN_URL || '/legacy/login';

const logIn = async (credentials: Credentials): Promise<boolean> => {
  const getLocaleCookie = (locale: string): string => {
    return `${process.env.VUE_APP_COOKIE_PREFIX}django_language=${locale}`;
  };

  const postUserCredentials = async (csrfToken: string | null, locale: string): Promise<AxiosResponse> => {
    const { username, password, rememberMe } = credentials;
    if (!csrfToken) throw new Error('Login Failed - csrf token cannot be null or empty');
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    formData.append('csrfmiddlewaretoken', csrfToken);
    if (rememberMe) formData.append('remember_me', 'true');
    document.cookie = getLocaleCookie(locale);
    // console.log('postUserCredentials', loginUrl);
    return http.post(loginUrl, formData, { withCredentials: true });
  };

  let isUserLoggedIn = false;
  try {
    // console.log('loginUrl', loginUrl);
    const loginGetResponse = await http.get(loginUrl);
    // check if user already has a valid sessionid
    isUserLoggedIn = loginService.validateLoginResponse(loginGetResponse);
    if (!isUserLoggedIn) {
      // get CSRF token from the login page
      const csrfToken = loginMapper.extractCsrfTokenFromResponse(loginGetResponse.data);
      console.log('csrfToken', csrfToken);
      // post user credentials to log them in
      const locale = languageService.getDefaultLocale();
      const loginPostResponse = await postUserCredentials(csrfToken, locale);
      isUserLoggedIn = loginService.validateLoginResponse(loginPostResponse);
    }
  } catch (error) {
    throw new CxServiceUnavailableError(error);
  }
  return isUserLoggedIn;
};

const loginApi = { logIn };

export default loginApi;
